<template>
  <div class="gc-empty">
    <div class="gc-empty-mark" aria-hidden="true">
      <v-icon size="28" color="#5c6570">mdi-cart-outline</v-icon>
    </div>
    <h2>{{ title || "Oops! We couldn't find any matches!" }}</h2>
    <p>{{ subtitle || "Please try searching for something else" }}</p>
    <router-link to="/" class="gc-empty-home">Go to Home</router-link>
  </div>
</template>

<script>
export default {
  name: "NotFound",

  props: ["title", "subtitle"],
};
</script>

<style scoped>
.gc-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 56px 16px;
  color: #1c2430;
}

.gc-empty-mark {
  width: 64px;
  height: 64px;
  display: grid;
  place-items: center;
  margin-bottom: 16px;
  border: 1px solid #e6e8ee;
  border-radius: 16px;
  background: transparent;
}

.gc-empty h2 {
  margin: 0 0 8px;
  font-size: 1.15rem;
  font-weight: 600;
  line-height: 1.3;
}

.gc-empty p {
  margin: 0;
  max-width: 36ch;
  color: #5c6570;
  line-height: 1.5;
}

.gc-empty-home {
  margin-top: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0 16px;
  border: 1px solid #e6e8ee;
  border-radius: 999px;
  background: #fff;
  color: #1c2430;
  font-weight: 600;
  text-decoration: none;
}

.gc-empty-home:hover {
  border-color: #c5cad3;
  color: #1c2430;
}

.gc-empty-home:focus-visible {
  outline: 2px solid var(--primary, #007bff);
  outline-offset: 2px;
}
</style>
